import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { DetailedOffer } from '../../../../../../api-client/models/offer/DetailedOffer';
import { ChevronIcon, CustomLink } from '../../../../../../components';
import DetailedProjectContextProvider, {
  DetailedProjectContextType,
} from '../../../../../../components/pages/detailed-project/DetailedProjectContext/DetailedProjectContext';
import DetailedProjectMobileNavigation from '../../../../../../components/pages/detailed-project/DetailedProjectMobileNavigation';
import { RouteDictionary } from '../../../../../../utils';
import SecondaryProjectContextProvider from '../SecondaryProjectContext';
import { SecondaryProjectContextType } from '../SecondaryProjectContext/SecondaryProjectContext';
import SecondaryProjectInvest from '../SecondaryProjectInvest';
import SecondaryProjectMain from '../SecondaryProjectMain';

import './SecondaryProject.scoped.scss';
type Props = {
  offer: DetailedOffer;
};

const SecondaryProject: FC<Props> = ({ offer }) => {
  const value: SecondaryProjectContextType = {
    offer: offer,
  };
  const detailedProjectValue: DetailedProjectContextType = {
    project: offer.project,
  };
  return (
    <SecondaryProjectContextProvider props={value}>
      <DetailedProjectContextProvider props={detailedProjectValue}>
        <CustomLink className="secondary-project-back" to={RouteDictionary.PRIMARY_MARKET}>
          <ChevronIcon direction="down" title="К списку проектов" color={'var(--black-color)'} />
        </CustomLink>
        <div className="secondary-project">
          <SecondaryProjectMain />
          <SecondaryProjectInvest />
          <div className="secondary-project-outlet">
            <DetailedProjectMobileNavigation />
            <Outlet />
          </div>
        </div>
      </DetailedProjectContextProvider>
    </SecondaryProjectContextProvider>
  );
};

export default SecondaryProject;
